
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.33840',
  depVersions: {
  "documents-public-ui": "static-1.33840",
  "client-types": "static-1.444",
  "documents-lib": "static-1.33845",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.1874",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4754",
  "highcharts": "static-8.98",
  "hs-promise-utils": "static-1.5341",
  "hs-test-utils": "static-1.7752",
  "hub-http": "static-1.5872",
  "hubspot-dlb": "static-2.1786",
  "HubStyleTokens": "static-2.11172",
  "I18n": "static-7.1556",
  "jasmine-immutable": "static-1.2769",
  "jasmine-runner": "static-1.6221",
  "lodash": "static-1.3",
  "quartz": "static-1.6660",
  "react": "static-7.176",
  "react-dlb": "static-1.70",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.66",
  "react-rhumb": "static-1.16389",
  "reporting-data": "static-1.66303",
  "reporting-testing-lib": "static-1.8236",
  "reporting-visualizations": "static-1.58379",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4512",
  "webpack-env": "static-1.54",
  "atom": "static-1.4821",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2232",
  "classnames": "static-2.10",
  "crm_schema": "static-3.90919",
  "cssUtils": "static-1.716",
  "customer-data-filters-ui": "static-1.38695",
  "customer-data-objects": "static-1.7388",
  "customer-data-property-utils": "static-1.7822",
  "data-fetching-client": "static-1.9427",
  "enviro": "static-4.387",
  "FireAlarmUi": "static-1.4282",
  "flux-actions": "static-1.302",
  "FormsCommonComponents": "static-1.85162",
  "FormUrlGenerator": "static-2.4481",
  "foundations-components": "static-1.7423",
  "history": "static-4.47",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.3873",
  "HubStyle": "static-2.11480",
  "icons": "static-2.618",
  "immutable": "static-2.19",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.6910",
  "metrics-js": "static-1.9346",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.349",
  "property-description-translator": "static-1.3610",
  "property-translator": "static-1.5164",
  "quartz-config": "static-1.438",
  "quartz-core": "static-1.5879",
  "quick-fetch": "static-1.3687",
  "raven": "static-3.5624",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5131",
  "react-virtualized": "static-2.93",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7910",
  "reference-resolvers-lite": "static-1.7840",
  "report-customization-components": "static-1.12349",
  "reporting-enablement": "static-1.21899",
  "reporting-reports": "static-1.65981",
  "reporting-snowflake": "static-1.54921",
  "reporting-ui-components": "static-2.63575",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4380",
  "sales-content-partitioning": "static-1.8685",
  "SalesContentIndexUI": "static-3.8820",
  "sanitize": "static-1.4225",
  "sanitize-text": "static-1.7890",
  "self-service-api": "static-1.9997",
  "SharedI18nStrings": "static-1.180",
  "SharedLegalStrings": "static-1.1500",
  "signup-constants": "static-1.18284",
  "signup-ui-lego-core": "static-1.20294",
  "signup-ui-url-generator": "static-2.7808",
  "styled-components": "static-2.84",
  "StyleGuideUI": "static-3.482",
  "superstore": "static-1.4522",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10745",
  "ui-addon-i18n": "static-1.10881",
  "ui-addon-react-router-dom": "static-1.9297",
  "ui-addon-upgrades": "static-9.17555",
  "ui-asset-management-lib": "static-1.10633",
  "ui-images": "static-2.1076",
  "UIComponents": "static-3.8119",
  "usage-tracker": "static-1.7084",
  "usage-tracker-container": "static-1.7074",
  "usage-tracker-core": "static-1.6934",
  "usage-tracker-public": "static-1.6895",
  "viral-links-lib": "static-1.6775",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven-hubspot": "static-1.5931",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3183",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2937",
  "quartz-webpack": "static-1.2884",
  "ai-components-ui-library": "static-1.8209",
  "amplitude-session-replay-browser": "static-1.54",
  "foundations-assets": "static-1.4582",
  "foundations-theming": "static-1.4158",
  "quartz-auth": "static-1.335",
  "usage-tracker-session-replay": "static-1.4770",
  "foundations-theming-base": "static-1.3143",
  "HeadJS": "static-2.701",
  "framer-motion": "static-1.66",
  "hs-test-utils-bend-plugin": "static-1.2863",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4081",
  "csstype": "static-1.50",
  "frontend-preferences-client": "static-1.7677",
  "graphql": "static-1.76",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3453",
  "reporting-client-types": "static-1.2368",
  "hs-story-utils": "static-1.9178",
  "react-flip-move": "static-1.64",
  "hub-http-shared-msw-handlers": "static-1.9350",
  "hubspotter-http": "static-1.4435",
  "sassPrefix": "static-1.150",
  "conversations-skeleton-state": "static-1.6999",
  "crm-message-bus": "static-1.42193",
  "customer-data-filters-ui-msw-helpers": "static-1.21129",
  "customer-data-objects-ui-components": "static-1.12753",
  "customer-data-reference-ui-components": "static-1.12891",
  "customer-data-ui-utilities": "static-1.9575",
  "framework-builder-read-service-client": "static-1.3804",
  "framework-data-schema-quick-fetch": "static-1.6524",
  "framework-data-schema-resolvers": "static-1.6619",
  "inbound-db-properties-service-client": "static-1.3635",
  "multi-account-reference-resolvers": "static-1.719",
  "onboarding-tours": "static-1.16192",
  "reporting-datasets-permissions-lib": "static-1.12896",
  "ui-addon-teams": "static-1.21163",
  "apollo-stack-hubspot": "static-3.80",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.67471",
  "customer-data-properties": "static-1.50612",
  "forms-ai-lib": "static-1.3936",
  "forms-utils-lib": "static-1.12072",
  "foundations-components-test-utils": "static-1.4906",
  "react-dnd-compat": "static-1.4374",
  "react-tinymce": "static-1.54484",
  "tinymce-config": "static-2.53610",
  "ui-gdpr-components": "static-1.10097",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.3692",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "tanstack-table": "static-1.49",
  "trellis-assets": "static-1.1064",
  "ui-fonts": "static-1.434",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.784",
  "mobile-manifest-mixins": "static-1.474",
  "quartz-head": "static-1.325",
  "quartz-i18n": "static-1.335",
  "quartz-routing": "static-1.90",
  "quartz-test": "static-1.335",
  "batch-promise": "static-1.1296",
  "external-options-client-types": "static-1.3940",
  "react-colorpicker": "static-2.9962",
  "copilot-toolkit": "static-1.10394",
  "data-quality-ui-library": "static-1.12198",
  "html-to-image": "static-1.48",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40497",
  "reporting-insights-lib": "static-1.1006",
  "reporting-plugins": "static-1.9919",
  "ui-addon-draggable-compat": "static-2.4004",
  "ui-addon-opt": "static-4.8138",
  "ui-shepherd-react": "static-3.9895",
  "zustand": "static-1.51",
  "growth-payments-core": "static-1.24574",
  "hubspot-apollo-client": "static-1.4629",
  "sales-templates-service-types-lib": "static-1.3950",
  "ui-business-units-lib": "static-1.8772",
  "merchandise-lib": "static-1.256",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5399",
  "salesImages": "static-1.519",
  "ts-schema": "static-1.3861",
  "upgrade-management-service-types": "static-1.4258",
  "timezone-utils": "static-2.4994",
  "bender-build-tools": "static-1.2886",
  "chatspot-core": "static-1.20117",
  "chirp-fetch": "static-1.1632",
  "bend-plugin-foundations-theming": "static-1.2641",
  "stylex": "static-1.26",
  "hubspotter-http-shared-msw-handlers": "static-1.9348",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3580",
  "crm-pipelines-api-client-types": "static-1.3921",
  "multi-currency-client-types": "static-1.3475",
  "getting-started-shared-tasks": "static-1.17732",
  "growth-data-modal": "static-1.5101",
  "growth-onboarding-confetti": "static-1.2817",
  "growth-onboarding-next-action-utils": "static-1.1245",
  "navigation-components": "static-1.17107",
  "onboarding-tours-client": "static-1.4406",
  "onboarding-tours-utils": "static-1.258",
  "ui-shepherd-tracker": "static-1.7276",
  "ui-universal-auth": "static-1.8626",
  "user-context": "static-1.4845",
  "cms-field-types": "static-1.4557",
  "content-icons-ui": "static-1.2136",
  "integrations-lib": "static-1.15251",
  "calling-global-api": "static-1.63500",
  "calling-internal-common": "static-1.31042",
  "calling-lifecycle-internal": "static-1.64882",
  "calling-lifecycle-messages": "static-1.57176",
  "commerce-products-lib": "static-1.8691",
  "crm-links": "static-1.6002",
  "file-manager-components": "static-1.22733",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.420",
  "inbounddb-objects-service-types": "static-1.4007",
  "meetings-icalendar-utils-lib": "static-1.384",
  "object-builder-ui-client": "static-1.47801",
  "pipeline-validation-client-types": "static-1.3744",
  "property-value-citations": "static-1.1226",
  "pulse": "static-1.250",
  "smart-property-lib": "static-1.5696",
  "tiered-pricing": "static-1.745",
  "ui-addon-iframeable": "static-1.8787",
  "final-form": "static-1.64",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19387",
  "tinymce-themes": "static-1.55580",
  "data-token-picker": "static-1.15965",
  "hub-http-contrib": "static-1.2795",
  "interframe": "static-3.4542",
  "tinymce-data": "static-1.39695",
  "tinymce-plugins": "static-1.56724",
  "ui-addon-sales-email": "static-1.4963",
  "magpie-lib": "static-1.5341",
  "magpie-types": "static-1.4801",
  "simple-logging-lib": "static-1.2801",
  "content-assistance-lib": "static-1.7375",
  "dashboard-lib": "static-1.80403",
  "ExportDialog": "static-6.10138",
  "hubspot-prosemirror": "static-1.17458",
  "hubspot-prosemirror-plugins": "static-1.17450",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8440",
  "campaign-roi-lib": "static-1.8126",
  "feedback-loader": "static-1.28760",
  "onboarding-scopes": "static-1.6211",
  "apollo-link-hub-http": "static-2.4399",
  "hubspot-apollo-cache": "static-1.88",
  "growth-monetization-service-types": "static-1.4274",
  "nav-client-types": "static-1.2102",
  "purchase-motions-api": "static-1.5402",
  "trials-service-types": "static-1.3675",
  "chatspot-client-types": "static-1.10414",
  "idb-keyval": "static-1.38",
  "reactive-lib": "static-1.476",
  "getting-started-shared-tasks-store": "static-1.16850",
  "integrations-error-boundary-lib": "static-1.12666",
  "integrations-tracking-lib": "static-1.5334",
  "native-integrations-shared-strings": "static-1.7539",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10123",
  "rxjs": "static-5.10",
  "calling-error-reporting": "static-1.31048",
  "shared-worker-versioning": "static-1.10785",
  "calling-usage-tracker": "static-1.6289",
  "voice-sms-access-library": "static-1.83",
  "customer-data-tracking": "static-1.6628",
  "products-iframe-lib": "static-1.7180",
  "products-ui-components-shared-msw-handlers": "static-1.9732",
  "location-customization-utils-lib": "static-1.8393",
  "apollo-dlb": "static-3.80",
  "immerable": "static-1.3905",
  "video-components-external": "static-1.10414",
  "video-data-lib": "static-1.34072",
  "directed-graph": "static-1.687",
  "event-emitter": "static-1.694",
  "breeze-intelligence-kit": "static-1.5245",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9433",
  "fsm": "static-1.3482",
  "policy-lib": "static-1.6538",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9496",
  "navigation-messaging": "static-1.6434",
  "FileManagerLib": "static-1.38373",
  "NamespacedHubStyle": "static-2.8853",
  "FileManagerCore": "static-1.38232",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11943",
  "layout-dnd-utils": "static-1.10918",
  "react-codemirror": "static-1.10374",
  "ui-addon-emoji-picker": "static-1.9640",
  "ui-brand-identity-lib": "static-1.13624",
  "ui-addon-video-player": "static-1.8444",
  "ui-coaching-tips": "static-1.27802",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8317",
  "payment-link-components": "static-1.22790",
  "EmailSignatureEditor": "static-1.23854",
  "eligibility-engine-service-types": "static-1.2956",
  "universal-page-editor-lib": "static-1.2749",
  "calling-orchestration-schema": "static-1.34860",
  "sales-views-client-types": "static-1.4044",
  "crm-record-cards-service-types": "static-1.3408",
  "content-media-composition-data-lib": "static-1.11276",
  "content-media-compositions": "static-2.15283",
  "media-bridge-lib": "static-1.18487",
  "trellis-story-utils": "static-1.4272",
  "storybook-react": "static-1.27",
  "audio-components": "static-1.5540",
  "FileManagerImages": "static-1.35884",
  "video-components": "static-1.12417",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4283",
  "video-embed": "static-1.34906",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67546",
  "layout-data-lib": "static-1.9243",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6336",
  "commerce-tours-lib": "static-1.5637",
  "growth-onboarding-reliability": "static-1.4839",
  "sales-checkout-service-client": "static-1.3430",
  "draft-convert": "static-2.31",
  "draft-extend": "static-3.69",
  "draft-js": "static-5.37",
  "draft-plugins": "static-2.21224",
  "sales-email-signature-service-client": "static-1.3593",
  "hls.js": "static-1.33",
  "social-insights-client-types": "static-1.21206",
  "outpost": "static-1.3958",
  "advanced-menus-core": "static-1.14741",
  "advanced-menus-lib": "static-1.11727",
  "ui-memberships-settings-lib": "static-1.33290",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14740",
  "simple-menus-lib": "static-1.16257"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.33840",
  "client-types": "/client-types/static-1.444",
  "documents-lib": "/documents-lib/static-1.33845",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1874",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4754",
  "highcharts": "/highcharts/static-8.98",
  "hs-promise-utils": "/hs-promise-utils/static-1.5341",
  "hs-test-utils": "/hs-test-utils/static-1.7752",
  "hub-http": "/hub-http/static-1.5872",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "HubStyleTokens": "/HubStyleTokens/static-2.11172",
  "I18n": "/I18n/static-7.1556",
  "jasmine-immutable": "/jasmine-immutable/static-1.2769",
  "jasmine-runner": "/jasmine-runner/static-1.6221",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6660",
  "react": "/react/static-7.176",
  "react-dlb": "/react-dlb/static-1.70",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.66",
  "react-rhumb": "/react-rhumb/static-1.16389",
  "reporting-data": "/reporting-data/static-1.66303",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8236",
  "reporting-visualizations": "/reporting-visualizations/static-1.58379",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4512",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.4821",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2232",
  "classnames": "/classnames/static-2.10",
  "crm_schema": "/crm_schema/static-3.90919",
  "cssUtils": "/cssUtils/static-1.716",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38695",
  "customer-data-objects": "/customer-data-objects/static-1.7388",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7822",
  "data-fetching-client": "/data-fetching-client/static-1.9427",
  "enviro": "/enviro/static-4.387",
  "FireAlarmUi": "/FireAlarmUi/static-1.4282",
  "flux-actions": "/flux-actions/static-1.302",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85162",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4481",
  "foundations-components": "/foundations-components/static-1.7423",
  "history": "/history/static-4.47",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyle": "/HubStyle/static-2.11480",
  "icons": "/icons/static-2.618",
  "immutable": "/immutable/static-2.19",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.6910",
  "metrics-js": "/metrics-js/static-1.9346",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "property-description-translator": "/property-description-translator/static-1.3610",
  "property-translator": "/property-translator/static-1.5164",
  "quartz-config": "/quartz-config/static-1.438",
  "quartz-core": "/quartz-core/static-1.5879",
  "quick-fetch": "/quick-fetch/static-1.3687",
  "raven": "/raven/static-3.5624",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5131",
  "react-virtualized": "/react-virtualized/static-2.93",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7910",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7840",
  "report-customization-components": "/report-customization-components/static-1.12349",
  "reporting-enablement": "/reporting-enablement/static-1.21899",
  "reporting-reports": "/reporting-reports/static-1.65981",
  "reporting-snowflake": "/reporting-snowflake/static-1.54921",
  "reporting-ui-components": "/reporting-ui-components/static-2.63575",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4380",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8685",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8820",
  "sanitize": "/sanitize/static-1.4225",
  "sanitize-text": "/sanitize-text/static-1.7890",
  "self-service-api": "/self-service-api/static-1.9997",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1500",
  "signup-constants": "/signup-constants/static-1.18284",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20294",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7808",
  "styled-components": "/styled-components/static-2.84",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "superstore": "/superstore/static-1.4522",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10745",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10881",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9297",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17555",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10633",
  "ui-images": "/ui-images/static-2.1076",
  "UIComponents": "/UIComponents/static-3.8119",
  "usage-tracker": "/usage-tracker/static-1.7084",
  "usage-tracker-container": "/usage-tracker-container/static-1.7074",
  "usage-tracker-core": "/usage-tracker-core/static-1.6934",
  "usage-tracker-public": "/usage-tracker-public/static-1.6895",
  "viral-links-lib": "/viral-links-lib/static-1.6775",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3183",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2937",
  "quartz-webpack": "/quartz-webpack/static-1.2884",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8209",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4582",
  "foundations-theming": "/foundations-theming/static-1.4158",
  "quartz-auth": "/quartz-auth/static-1.335",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4770",
  "foundations-theming-base": "/foundations-theming-base/static-1.3143",
  "HeadJS": "/HeadJS/static-2.701",
  "framer-motion": "/framer-motion/static-1.66",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2863",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4081",
  "csstype": "/csstype/static-1.50",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7677",
  "graphql": "/graphql/static-1.76",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3453",
  "reporting-client-types": "/reporting-client-types/static-1.2368",
  "hs-story-utils": "/hs-story-utils/static-1.9178",
  "react-flip-move": "/react-flip-move/static-1.64",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9350",
  "hubspotter-http": "/hubspotter-http/static-1.4435",
  "sassPrefix": "/sassPrefix/static-1.150",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6999",
  "crm-message-bus": "/crm-message-bus/static-1.42193",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21129",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12753",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12891",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9575",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3804",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6524",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6619",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3635",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.719",
  "onboarding-tours": "/onboarding-tours/static-1.16192",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12896",
  "ui-addon-teams": "/ui-addon-teams/static-1.21163",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.80",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.67471",
  "customer-data-properties": "/customer-data-properties/static-1.50612",
  "forms-ai-lib": "/forms-ai-lib/static-1.3936",
  "forms-utils-lib": "/forms-utils-lib/static-1.12072",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4906",
  "react-dnd-compat": "/react-dnd-compat/static-1.4374",
  "react-tinymce": "/react-tinymce/static-1.54484",
  "tinymce-config": "/tinymce-config/static-2.53610",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10097",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3692",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.49",
  "trellis-assets": "/trellis-assets/static-1.1064",
  "ui-fonts": "/ui-fonts/static-1.434",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.784",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.474",
  "quartz-head": "/quartz-head/static-1.325",
  "quartz-i18n": "/quartz-i18n/static-1.335",
  "quartz-routing": "/quartz-routing/static-1.90",
  "quartz-test": "/quartz-test/static-1.335",
  "batch-promise": "/batch-promise/static-1.1296",
  "external-options-client-types": "/external-options-client-types/static-1.3940",
  "react-colorpicker": "/react-colorpicker/static-2.9962",
  "copilot-toolkit": "/copilot-toolkit/static-1.10394",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12198",
  "html-to-image": "/html-to-image/static-1.48",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40497",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1006",
  "reporting-plugins": "/reporting-plugins/static-1.9919",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4004",
  "ui-addon-opt": "/ui-addon-opt/static-4.8138",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9895",
  "zustand": "/zustand/static-1.51",
  "growth-payments-core": "/growth-payments-core/static-1.24574",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4629",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3950",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8772",
  "merchandise-lib": "/merchandise-lib/static-1.256",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5399",
  "salesImages": "/salesImages/static-1.519",
  "ts-schema": "/ts-schema/static-1.3861",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4258",
  "timezone-utils": "/timezone-utils/static-2.4994",
  "bender-build-tools": "/bender-build-tools/static-1.2886",
  "chatspot-core": "/chatspot-core/static-1.20117",
  "chirp-fetch": "/chirp-fetch/static-1.1632",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2641",
  "stylex": "/stylex/static-1.26",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9348",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3580",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3921",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3475",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17732",
  "growth-data-modal": "/growth-data-modal/static-1.5101",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2817",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1245",
  "navigation-components": "/navigation-components/static-1.17107",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4406",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.258",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7276",
  "ui-universal-auth": "/ui-universal-auth/static-1.8626",
  "user-context": "/user-context/static-1.4845",
  "cms-field-types": "/cms-field-types/static-1.4557",
  "content-icons-ui": "/content-icons-ui/static-1.2136",
  "integrations-lib": "/integrations-lib/static-1.15251",
  "calling-global-api": "/calling-global-api/static-1.63500",
  "calling-internal-common": "/calling-internal-common/static-1.31042",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64882",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57176",
  "commerce-products-lib": "/commerce-products-lib/static-1.8691",
  "crm-links": "/crm-links/static-1.6002",
  "file-manager-components": "/file-manager-components/static-1.22733",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.420",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4007",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.384",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47801",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3744",
  "property-value-citations": "/property-value-citations/static-1.1226",
  "pulse": "/pulse/static-1.250",
  "smart-property-lib": "/smart-property-lib/static-1.5696",
  "tiered-pricing": "/tiered-pricing/static-1.745",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8787",
  "final-form": "/final-form/static-1.64",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19387",
  "tinymce-themes": "/tinymce-themes/static-1.55580",
  "data-token-picker": "/data-token-picker/static-1.15965",
  "hub-http-contrib": "/hub-http-contrib/static-1.2795",
  "interframe": "/interframe/static-3.4542",
  "tinymce-data": "/tinymce-data/static-1.39695",
  "tinymce-plugins": "/tinymce-plugins/static-1.56724",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4963",
  "magpie-lib": "/magpie-lib/static-1.5341",
  "magpie-types": "/magpie-types/static-1.4801",
  "simple-logging-lib": "/simple-logging-lib/static-1.2801",
  "content-assistance-lib": "/content-assistance-lib/static-1.7375",
  "dashboard-lib": "/dashboard-lib/static-1.80403",
  "ExportDialog": "/ExportDialog/static-6.10138",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17458",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17450",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8440",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8126",
  "feedback-loader": "/feedback-loader/static-1.28760",
  "onboarding-scopes": "/onboarding-scopes/static-1.6211",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4399",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.88",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4274",
  "nav-client-types": "/nav-client-types/static-1.2102",
  "purchase-motions-api": "/purchase-motions-api/static-1.5402",
  "trials-service-types": "/trials-service-types/static-1.3675",
  "chatspot-client-types": "/chatspot-client-types/static-1.10414",
  "idb-keyval": "/idb-keyval/static-1.38",
  "reactive-lib": "/reactive-lib/static-1.476",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16850",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12666",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5334",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7539",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10123",
  "rxjs": "/rxjs/static-5.10",
  "calling-error-reporting": "/calling-error-reporting/static-1.31048",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10785",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6289",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.83",
  "customer-data-tracking": "/customer-data-tracking/static-1.6628",
  "products-iframe-lib": "/products-iframe-lib/static-1.7180",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9732",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8393",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "immerable": "/immerable/static-1.3905",
  "video-components-external": "/video-components-external/static-1.10414",
  "video-data-lib": "/video-data-lib/static-1.34072",
  "directed-graph": "/directed-graph/static-1.687",
  "event-emitter": "/event-emitter/static-1.694",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5245",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9433",
  "fsm": "/fsm/static-1.3482",
  "policy-lib": "/policy-lib/static-1.6538",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9496",
  "navigation-messaging": "/navigation-messaging/static-1.6434",
  "FileManagerLib": "/FileManagerLib/static-1.38373",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8853",
  "FileManagerCore": "/FileManagerCore/static-1.38232",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11943",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10918",
  "react-codemirror": "/react-codemirror/static-1.10374",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9640",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13624",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8444",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27802",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8317",
  "payment-link-components": "/payment-link-components/static-1.22790",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23854",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2956",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2749",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34860",
  "sales-views-client-types": "/sales-views-client-types/static-1.4044",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3408",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11276",
  "content-media-compositions": "/content-media-compositions/static-2.15283",
  "media-bridge-lib": "/media-bridge-lib/static-1.18487",
  "trellis-story-utils": "/trellis-story-utils/static-1.4272",
  "storybook-react": "/storybook-react/static-1.27",
  "audio-components": "/audio-components/static-1.5540",
  "FileManagerImages": "/FileManagerImages/static-1.35884",
  "video-components": "/video-components/static-1.12417",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4283",
  "video-embed": "/video-embed/static-1.34906",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67546",
  "layout-data-lib": "/layout-data-lib/static-1.9243",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6336",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5637",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4839",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3430",
  "draft-convert": "/draft-convert/static-2.31",
  "draft-extend": "/draft-extend/static-3.69",
  "draft-js": "/draft-js/static-5.37",
  "draft-plugins": "/draft-plugins/static-2.21224",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3593",
  "hls.js": "/hls.js/static-1.33",
  "social-insights-client-types": "/social-insights-client-types/static-1.21206",
  "outpost": "/outpost/static-1.3958",
  "advanced-menus-core": "/advanced-menus-core/static-1.14741",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11727",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33290",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14740",
  "simple-menus-lib": "/simple-menus-lib/static-1.16257"
}
};
